"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var create_rocket_1 = require("../_util/create-rocket");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var justify_1 = require("../justify");
var config_context_1 = require("../_util/config-context");
var heading_1 = require("../heading");
var util_1 = require("../util");
var warn_1 = require("../_util/warn");
var CardHeader = create_rocket_1.createRocket("CardHeader", "div.@{prefix}-card__header");
var CardFooter = create_rocket_1.createRocket("CardFooter", "div.@{prefix}-card__footer");
var CardBody = react_1.forwardRef(function (props, ref) {
    var classPrefix = config_context_1.useConfig().classPrefix;
    var className = props.className, style = props.style, title = props.title, subtitle = props.subtitle, operation = props.operation, children = props.children;
    return (react_1.default.createElement("div", { ref: ref, className: classnames_1.default(classPrefix + "-card__body", className), style: style },
        (title || subtitle || operation) && (react_1.default.createElement("div", { className: classPrefix + "-card__title" },
            react_1.default.createElement(justify_1.Justify, { left: react_1.default.createElement(heading_1.H3, null,
                    title,
                    subtitle && (react_1.default.createElement("span", { className: classPrefix + "-card__subtitle" }, subtitle))), right: operation }))),
        react_1.default.createElement("div", { className: classPrefix + "-card__content" }, children)));
});
CardBody.displayName = "CardBody";
exports.Card = forward_ref_with_statics_1.forwardRefWithStatics(function (_a, ref) {
    var _b;
    var className = _a.className, children = _a.children, bordered = _a.bordered, full = _a.full, props = tslib_1.__rest(_a, ["className", "children", "bordered", "full"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    var containerRef = react_1.useRef();
    // 视觉升级特殊判断，内层直接为新版空白页时 card 样式属性不生效
    var _c = tslib_1.__read(react_1.useState(true), 2), useClass = _c[0], setUseClass = _c[1];
    react_1.useLayoutEffect(function () {
        var _a;
        if (containerRef.current) {
            if (containerRef.current.childElementCount === 1 && ((_a = containerRef.current.children[0]) === null || _a === void 0 ? void 0 : _a.className.includes(classPrefix + "-blank-page-v2"))) {
                warn_1.warn("新版本 Blank 组件已无需 Card 包裹，建议移除外层 Card 组件");
                setUseClass(false);
            }
            else {
                setUseClass(true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [children]);
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: util_1.mergeRefs(containerRef, ref), className: useClass
            ? classnames_1.default(classPrefix + "-card", (_b = {},
                _b[classPrefix + "-card--bordered"] = bordered,
                _b[classPrefix + "-card--full"] = full === true,
                _b[classPrefix + "-card--full-with-header"] = full === "withHeader",
                _b), className)
            : className }, props), children));
}, 
// Card statics
{
    Header: CardHeader,
    Body: CardBody,
    Footer: CardFooter,
});
exports.Card.displayName = "Card";
//# sourceMappingURL=Card.js.map